import { SectionSwitcher } from "../../../jobs-flow/SectionSwitcher";

export const PaymentMethodInterface = {
    setAsPrimary() {
        return new Promise((resolve,reject)=>{
            $.ajax({
                method: 'PATCH',
                url: `${this.urlRoot}/${this.id}/set-primary`,
                success: () => resolve(true),
                error:()=>resolve(false)
            });
        })
    },

    setAsBackup() {
        return new Promise((resolve,reject)=>{
            $.ajax({
                method: 'PATCH',
                url: `${this.urlRoot}/${this.id}/set-backup`,
                success: () => resolve(true),
                error:()=>resolve(false)
            });
        })
    }
}
